import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Electricmeter } from './electricmeter.model';
import { ElectricmeterPopupService } from './electricmeter-popup.service';
import { ElectricmeterService } from './electricmeter.service';

@Component({
    selector: 'jhi-electricmeter-delete-dialog',
    templateUrl: './electricmeter-delete-dialog.component.html'
})
export class ElectricmeterDeleteDialogComponent {

    electricmeter: Electricmeter;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private electricmeterService: ElectricmeterService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['electricmeter']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.electricmeterService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'electricmeterListModification',
                content: 'Deleted an electricmeter'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-electricmeter-delete-popup',
    template: ''
})
export class ElectricmeterDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private electricmeterPopupService: ElectricmeterPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.electricmeterPopupService
                .open(ElectricmeterDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter-delete-dialog.component.ts